import { BaseGridDocumentComponent } from '@dato-pages/base/base-grid-document-component';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { Component } from '@angular/core';
import { Invoice } from '@dato-proxy/entities/invoice.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-invoice-grid',
    templateUrl: './invoice-grid.component.html',
    styleUrls: ['./invoice-grid.component.scss']
})
export class InvoiceGridComponent extends BaseGridDocumentComponent<Invoice> {

    constructor(A: ServiceBagService) {
        super(A, 'InvoiceGridComponent', Invoice);
    }
}
